import { render } from "./Endereco.vue?vue&type=template&id=2a516359&scoped=true"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"

import "./Endereco.vue?vue&type=style&index=0&id=2a516359&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a516359"]])

export default __exports__